// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__26vva","label":"Radio_label__bm9bg","checkMark":"Radio_checkMark__nHnZe","disabled":"Radio_disabled__2mdWS"};